import { render, staticRenderFns } from "./LifefileOrderRxDetails.vue?vue&type=template&id=5ab18053&scoped=true"
import script from "./LifefileOrderRxDetails.vue?vue&type=script&lang=js"
export * from "./LifefileOrderRxDetails.vue?vue&type=script&lang=js"
import style0 from "./LifefileOrderRxDetails.vue?vue&type=style&index=0&id=5ab18053&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab18053",
  null
  
)

export default component.exports